import { LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { ForCheckInEmailTemplates } from "../for-check-in/email-templates";
import { ForCheckOutEmailTemplates } from "../for-check-out";
import { ForTriggerReservationEmailTemplates } from "../for-trigger-reservation/email-templates";
import { usePlanEmailTemplates } from "../hooks";

import type { DayTripPlanI18nCategoriesAndManagerStore } from "../../../../../_store/categories";

type Props = {
	email: DayTripPlanI18nCategoriesAndManagerStore["email"];
	hotelEmailAddress: string;
};

export const QuestionPlanEmailTemplates = ({ email, hotelEmailAddress }: Props) => {
	const {
		isEdited,
		hasError,
		// 予約確定
		atCreated,
		onSetAtCreatedForText,
		handleClickedSendTestEmailReservationCreated,
		// 予約変更
		atUpdated,
		onSetAtUpdatedForText,
		handleClickedSendTestEmailReservationUpdated,
		// 予約キャンセル
		atCanceled,
		onSetAtCanceledForText,
		handleClickedSendTestEmailReservationCanceled,
		// チェックイン7日前
		atCheckInBefore_07days,
		onSetAtCheckInBefore_07daysForText,
		handleClickedSendTestEmailReservationAtCheckInBefore_07days,
		// チェックイン1日前
		atCheckInBefore_01days,
		onSetAtCheckInBefore_01daysForText,
		handleClickedSendTestEmailReservationAtCheckInBefore_01days,
		// チェックイン当日
		atCheckInBefore_00days,
		onSetAtCheckInBefore_00daysForText,
		handleClickedSendTestEmailReservationAtCheckInBefore_00days,
		// チェックアウト1日後
		atCheckOutAfter_01days,
		onSetAtCheckOutAfter_01daysForText,
		handleClickedSendTestEmailReservationAtCheckOutAfter_01days,
		basicCustomMailSetting,
		defaultPlanCustomMailSetting,
	} = usePlanEmailTemplates();

	return (
		<>
			{/* 予約確定・変更・キャンセル時 */}
			<FeatureIslandMainWithCategoryWrapper
				categoryStore={email}
				islandTitle="予約：確定・変更・キャンセルメールの内容設定"
				tooltipTitle="ゲストに送信されるメールの内容をカスタマイズできます。<br /> 「テスト送信」ボタンからテスト送信ができ、実際に確認できます。"
			>
				<ForTriggerReservationEmailTemplates
					isEdited={isEdited}
					hasError={hasError}
					hotelEmailAddress={hotelEmailAddress}
					atCreated={atCreated}
					onSetAtCreatedForText={onSetAtCreatedForText}
					onSendTestEmailReservationCreated={handleClickedSendTestEmailReservationCreated}
					atUpdated={atUpdated}
					onSetAtUpdatedForText={onSetAtUpdatedForText}
					onSendTestEmailReservationUpdated={handleClickedSendTestEmailReservationUpdated}
					atCanceled={atCanceled}
					onSetAtCanceledForText={onSetAtCanceledForText}
					onSendTestEmailReservationCanceled={handleClickedSendTestEmailReservationCanceled}
					basicCustomMailSetting={basicCustomMailSetting}
					defaultPlanCustomMailSetting={defaultPlanCustomMailSetting}
					lang={LangCode.En}
				/>
			</FeatureIslandMainWithCategoryWrapper>
			{/* チェックイン前 */}
			<FeatureIslandMainWithCategoryWrapper
				categoryStore={email}
				islandTitle="チェックイン前：リマインドの内容設定"
				tooltipTitle="チェックイン前にゲストに送信されるメールの内容をカスタマイズできます。<br /> 「テスト送信」ボタンからテスト送信ができ、実際に確認できます。"
			>
				<ForCheckInEmailTemplates
					lang={LangCode.En}
					isEdited={isEdited}
					hasError={hasError}
					hotelEmailAddress={hotelEmailAddress}
					atCheckInBefore_07days={atCheckInBefore_07days}
					onSetAtCheckInBefore_07daysForText={onSetAtCheckInBefore_07daysForText}
					onSendTestEmailCheckInBefore_07days={handleClickedSendTestEmailReservationAtCheckInBefore_07days}
					atCheckInBefore_01days={atCheckInBefore_01days}
					onSetAtCheckInBefore_01daysForText={onSetAtCheckInBefore_01daysForText}
					onSendTestEmailCheckInBefore_01days={handleClickedSendTestEmailReservationAtCheckInBefore_01days}
					atCheckInBefore_00days={atCheckInBefore_00days}
					onSetAtCheckInBefore_00daysForText={onSetAtCheckInBefore_00daysForText}
					onSendTestEmailCheckInBefore_00days={handleClickedSendTestEmailReservationAtCheckInBefore_00days}
					basicCustomMailSetting={basicCustomMailSetting}
					defaultPlanCustomMailSetting={defaultPlanCustomMailSetting}
				/>
			</FeatureIslandMainWithCategoryWrapper>
			{/* チェックアウト後 */}
			<FeatureIslandMainWithCategoryWrapper
				categoryStore={email}
				islandTitle="チェックアウト後：ご案内メール設定"
				tooltipTitle="チェックアウト後にゲストに送信されるメールの内容をカスタマイズできます。<br /> 「テスト送信」ボタンからテスト送信ができ、実際に確認できます。"
			>
				<ForCheckOutEmailTemplates
					lang={LangCode.En}
					isEdited={isEdited}
					hasError={hasError}
					hotelEmailAddress={hotelEmailAddress}
					atCheckOutAfter_01days={atCheckOutAfter_01days}
					onSetAtCheckOutAfter_01daysForText={onSetAtCheckOutAfter_01daysForText}
					onSendTestEmailCheckOutAfter_01days={handleClickedSendTestEmailReservationAtCheckOutAfter_01days}
					basicCustomMailSetting={basicCustomMailSetting}
					defaultPlanCustomMailSetting={defaultPlanCustomMailSetting}
				/>
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionPlanEmailTemplates.displayName = "QuestionPlanEmailTemplates";
